import { getAuth, User } from "firebase/auth"
import fbConf from "./FirebaseConf"
import { notify } from "./modules/notificationService"

// Command source enum, shared with the charger/backend (VLT-1404):
// 0 SRC_UNKNOWN, 1 SRC_APP, 2 SRC_APP_IOS, 3 SRC_APP_ANDROID, 4 SRC_FRONTEND, 5 SRC_BACKEND.
// This app always sends SRC_FRONTEND.
const SRC_FRONTEND = 4

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default async function Comm(endpoint: string, options: {[key: string]: any}, silent?: boolean) {

  // Capture the API segment (e.g. 'api-websocket') before the URL is rewritten below
  const apiSegment = endpoint.split('/')[1]

  endpoint = endpoint.replace(`/${endpoint.split('/')[1]}`, () => {
    switch (endpoint.split('/')[1]) {
      case 'api-admin':
        return 'https://api.admin.voltie.hu'
      case 'api-charger':
        return 'https://api.charger.voltie.hu'
      case 'api-log':
        return 'https://api.log.voltie.hu'
      case 'api-cdr':
        return 'https://api.cdr.voltie.hu'
      case 'api-notification':
        return 'https://api.notification.voltie.hu'
      case 'api-websocket':
        return 'https://api.websocket.voltie.hu'
      case 'api-firmware':
        return 'https://api.firmware.voltie.hu'
      case 'api-financial':
        return 'https://api.financial.voltie.hu'
      default:
        return ''
    }
  })

  if (!options.headers) {
    options.headers = {}
  }

  if (!options.headers.Authorization) {
    // Refresh the non-admin Firebase ID token on demand so it can't go stale after ~1h (VLT-2043).
    // Admins use a separate server JWT in localStorage, so leave that as-is.
    try {
      const auth = getAuth(fbConf)
      // On a cold load (e.g. a discarded tab) currentUser isn't hydrated yet; wait for the first auth-state emission
      const user = auth.currentUser ?? await new Promise<User | null>(resolve => {
        const unsubscribe = auth.onAuthStateChanged(u => { unsubscribe(); resolve(u) })
      })
      if (user) {
        const tokenResult = await user.getIdTokenResult()
        if (!tokenResult.claims.admin) localStorage.setItem('token', tokenResult.token)
      }
    } catch { /* fall back to the existing localStorage token */ }
    options.headers.Authorization = localStorage.getItem('token') || 'empty token'
  }

  options.headers['Access-Control-Allow-Origin'] = '*'
  options.headers['Access-Control-Allow-Credentials'] = 'true'
  options.headers['Access-Control-Allow-Headers'] = 'Content-Type'
  options.headers['Access-Control-Allow-Methods'] = 'GET,POST,PATCH,DELETE,PUT,OPTIONS'
  options.headers['key'] = 'x-api-key'

  // Tag every command sent to the charger over the websocket with its source, so the backend
  // can trace where a command came from. src goes in the message body next to msg_type (VLT-1517 / VLT-1404).
  if (apiSegment === 'api-websocket' && typeof options.body === 'string') {
    try {
      const parsedBody = JSON.parse(options.body)
      if (parsedBody && typeof parsedBody === 'object' && 'msg_type' in parsedBody && !('src' in parsedBody)) {
        parsedBody.src = SRC_FRONTEND
        options.body = JSON.stringify(parsedBody)
      }
    } catch { /* non-JSON body, leave it untouched */ }
  }

  const response = await fetch(endpoint, options)
  if (response.status == 401) {
    notify(`Unauthorized: ${response.status}`, "TEXT", "error")
    await getAuth(fbConf).signOut()
    localStorage.removeItem('token')
    setTimeout(() => {
      window.location.href = `/login?redirect=${location.pathname}`
    }, 2000)
    throw new Error(`Invalid token, signing out: ${new URL(endpoint).pathname}`)
  } else if ([400, 403, 404, 408, 409, 422, 429, 500, 502, 503, 504].includes(response.status)) {
    if (!silent) {
      // Only send out error notification is the user is an admin
      const idTokenResult = await getAuth(fbConf).currentUser?.getIdTokenResult()
      if (idTokenResult?.claims.admin) {
        notify(`Unexpected server response: ${response.status} ${new URL(endpoint).pathname}`, "TEXT", "error")
      }
    }
  }

  return response
}



// This version here makes bulletproof sure that a token is available before sending the fetch
// I dont think we can ever get here without a token, but i'll still leave it here just in case it needs to be used

/*import { getAuth } from "firebase/auth"
import fbConf from "./FirebaseConf"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// @ts-expect-error TS thinks that the return value might be undefined, but this is not right
export default async function Comm(endpoint: string, options: { [key: string]: any }): Promise<Response> {

  endpoint = endpoint.replace(`/${endpoint.split('/')[1]}`, () => {
    switch (endpoint.split('/')[1]) {
      case 'api-admin':
        return 'https://api.admin.voltie.hu'
      case 'api-charger':
        return 'https://api.charger.voltie.hu'
      case 'api-log':
        return 'https://api.log.voltie.hu'
      case 'api-cdr':
        return 'https://api.cdr.voltie.hu'
      case 'api-notification':
        return 'https://api.notification.voltie.hu'
      case 'api-websocket':
        return 'https://api.websocket.voltie.hu'
      case 'api-firmware':
        return 'https://api.firmware.voltie.hu'
      default:
        return ''
    }
  })

  if (!options.headers) {
    options.headers = {}
  }

  if (!options.headers.Authorization) {

    if (!localStorage.getItem('token')) {

      // If there is no token in localstorage, try and wait for it, than do the fetch when found
      let checkCounter = 0
      const checkIfTokenIsAvailableInterval = setInterval(() => {
        console.log('Checking for token')
        checkCounter += 1
        if (localStorage.getItem('token')) {
          clearInterval(checkIfTokenIsAvailableInterval)
          options.headers.Authorization = localStorage.getItem('token')
          return doTheFetch(endpoint, options)
        }
        if (checkCounter >= 100) {
          // Token not found after 10 seconds, something is not right, just try and do the fetch anywas so it logs the user out
          clearInterval(checkIfTokenIsAvailableInterval)
          options.headers.Authorization = ''
          return doTheFetch(endpoint, options)
        }
      }, 100)

    } else {
      // If the token is in the localstorage without waiting for it, just do the fetch
      options.headers.Authorization = localStorage.getItem('token')
      return doTheFetch(endpoint, options)
    }

  } else {
    // If there is already a token in the Authorization header, just do the fetch with that
    return doTheFetch(endpoint, options)
  }
}

async function doTheFetch(endpoint: string, options: { [key: string]: { [key: string]: string } }) {
  options.headers['Access-Control-Allow-Origin'] = '*'
  options.headers['Access-Control-Allow-Credentials'] = 'true'
  options.headers['Access-Control-Allow-Headers'] = 'Content-Type'
  options.headers['Access-Control-Allow-Methods'] = 'GET,POST,PATCH,DELETE,PUT,OPTIONS'
  options.headers['key'] = 'x-api-key'
  
  const response = await fetch(endpoint, options)
  if (response.status == 401) {
    console.log('Error: Invalid token')
    console.log(options.headers.Authorization)
    await getAuth(fbConf).signOut()
    localStorage.removeItem('token')
    location.href = '/login'
  }

  return response
}*/